import type { AgentId } from "./nav.js";

/** Starter chips for PromptInput Suggestions — keep short. */
export function suggestionsFor(
	agentId: AgentId,
	setupDone: boolean,
): string[] {
	switch (agentId) {
		case "onboarding":
			return setupDone
				? [
						"Summarize my company pack",
						"What should I connect next?",
						"Who approves spend and publishes?",
					]
				: [
						"Research https://",
						"What will you look at on the site?",
						"How does the company pack get used?",
					];
		case "paid_media":
			return [
				"Draft a paused search brief",
				"What can you do with Ads?",
				"How do spend approvals work?",
			];
		case "ga4_anomaly":
			return [
				"How do anomaly checks work?",
				"What do you need from GA4?",
				"Show last watch window",
			];
		case "seo":
			return [
				"What would you audit first?",
				"How do you use Search Console?",
				"When do you ship?",
			];
		case "content":
			return [
				"How do you match brand voice?",
				"Draft vs publish — what needs approval?",
				"What CMS do you support?",
			];
		case "social":
			return [
				"How do post approvals work?",
				"Which channels first?",
				"Show a sample calendar",
			];
		case "email":
			return [
				"What ESP can you use?",
				"How do sends get approved?",
				"Lifecycle vs campaign?",
			];
		case "creative":
			return [
				"What goes in a creative brief?",
				"Can you make ad variants?",
				"How do assets get approved?",
			];
		case "cro":
			return [
				"How do you pick tests?",
				"What needs GA4?",
				"When does a variant ship?",
			];
		case "local":
			return [
				"What do you need from GBP?",
				"How do reviews show up?",
				"Local vs SEO — who owns what?",
			];
		case "developer":
			return [
				"What’s connected for the site?",
				"GitHub vs Vercel — who owns what?",
				"Can you check DNS?",
			];
		case "reporting":
			return [
				"What does a weekly digest cover?",
				"Which sources do you pull?",
				"Recommend vs just report?",
			];
		default: {
			const _exhaustive: never = agentId;
			return _exhaustive;
		}
	}
}
